import { styled } from '@mui/material/styles';
import FileTypeIcon from 'src/components/File/FileIcon';

import { CarouselItemPropsType } from './types';
import CircularProgress from '@mui/material/CircularProgress';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

const Container = styled('div')({
  position: 'relative',
  height: '100%',
  width: '100%',
  cursor: 'pointer',
});

const ImageContainer = styled('div')({
  width: 92,
  height: 68,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const IconContainer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: undefined,
  '& svg': {
    width: 30,
    height: 32,
  },
});

const CarouselThumbnail = ({ file }: CarouselItemPropsType) => {
  const [imageError, setImageError] = useState(false);
  if (file.isLoading) {
    return (
      <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={20} />
      </Container>
    );
  }

  if ((file.isJpgPreview || file.isAvifPreview) && !imageError) {

    return (
      <Container>
        <ImageContainer>
          <img
            src={file.thumbnailSrc}
            alt={file.fileName}
            style={{
              width: 92,
              height: 68,
              objectFit: 'cover'
            }}
            onError={(error) => {
              return file.errorHandling(error, () => setImageError(true))
            }}
            crossOrigin='use-credentials'
          />
        </ImageContainer>
      </Container>
    )
  }

  return (
    <Container>
      <IconContainer>
        <FileTypeIcon type={file.type} />
      </IconContainer>
    </Container>
  );
};

export default observer(CarouselThumbnail);
